import React from 'react';
import moment from 'moment';
import _ from 'lodash';
import { EMPTY_GRID_DEFAULT_MESSAGE, } from '../../../../../modules/Constants';
import SearchBar from '../../../../searchbar/SearchBar';
import FieldSet from '../../../../fieldset/FieldSet';
import Grid from '../../../../grid/Grid';
import KsDlService from '../../../../../service/KsDlService';
import KsDlModal from './KsDlModal';
import '../UtilityView.css';

class KsDl extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      licenses: [],
      rows: [],
      headers: [],
    };
    this.comboFields = [
      {
        value: 'customerId',
        display: 'Customer ID',
      },
      {
        value: 'transactionId',
        display: 'Transaction ID',
      },
      {
        value: 'driversLicenseNumber',
        display: 'Drivers License Number',
      },
    ];
  }

  state = undefined;

  onRowSelect(row) {
    this.setState({
      selectedLicense: row,
    });
  }

  getLicenseActivity(event) {
    const { search, combo, } = event;
    this.reset();
    const vm = this;
    const rows = [];
    let headers = [];

    const criteria = {};
    criteria[combo.value] = search.value;

    const allowedKeys = [
      'id',
      'customerId',
      'transactionId',
      'driversLicenseNumber',
      'createdOn',
    ];

    KsDlService.getLicensesBySearchCriteria(criteria)
      .then((response) => {
        const { licenses, } = response.data;
        this.setState({ licenses, });
        if (licenses.length > 0) {
          headers = allowedKeys.map(header => ({
            value: header,
            display: _.startCase(header),
          }));

          licenses.forEach((license) => {
            const filtered = {};
            filtered.id = license.id;
            filtered.customerId = license.customerId;
            filtered.transactionId = license.renewalRequest.transactionId;
            filtered.driversLicenseNumber = license.renewalRequest.driversLicenseNumber;
            filtered.createdOn = moment(license.createdOn).utc().format();

            const row = Object.values(filtered);

            rows.push({ value: row, });
          });
          vm.setState({
            headers,
            rows,
          });
        }
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        event.kill();
      });
  }

  formatSelectedRowDisplay(license) {
    if (!license) {
      return null;
    }
    return (
      <div>
        <p>{`Selected ID: ${license.id}`}</p>
        <hr />
        <KsDlModal license={license} />
      </div>
    );
  }

  reset() {
    this.setState({
      licenses: [],
      selectedLicense: null,
      headers: [],
      rows: [],
    });
  }

  render() {
    const {
      licenses,
      headers,
      rows,
      selectedLicense,
    } = this.state;
    const style = {
      maxHeight: '400px',
      overflowY: 'auto',
    };
    return (
      <div className="container">
        <SearchBar comboFields={this.comboFields} onClick={data => this.getLicenseActivity(data)} />
        <div style={{ marginTop: '50px', }}>
          <FieldSet title="licenses" style={style}>
            <Grid
              headers={headers}
              rows={rows}
              onRowSelect={row => this.onRowSelect(licenses.find(x => x.id === row.id))}
              onEmptyGridMessage={EMPTY_GRID_DEFAULT_MESSAGE}
            />
          </FieldSet>
          {this.formatSelectedRowDisplay(selectedLicense)}
        </div>
      </div>
    );
  }
}

export default KsDl;
